import {
  BarController,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  Tooltip,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import dayjs from 'dayjs';
import { Chart } from 'react-chartjs-2';

import { Spinner } from './Spinner';
import { useFetchBookerCommissions } from '../hooks/useFetchBookerCommissions';
import { t } from '../services/translation/translation';

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
);

type Props = {
  receptionist?: string;
};

export const IncomeHistogram = ({ receptionist }: Props) => {
  const { data, isLoading } = useFetchBookerCommissions({
    invoiceMention: receptionist ? receptionist.toUpperCase() : undefined,
  });
  const buckets = data ? data.buckets : [];
  const labelsForBar = buckets.map(d => dayjs(new Date(d.date)).format('MMMM YYYY'));
  const amounts = buckets.map(d => d.amount);
  const trips = buckets.map(d => d.trips);
  return (
    <div className="pt-5 md:pb-5 md:px-5">
      <div className="h-72 md:h-96">
        {isLoading ? (
          <div className="flex items-center justify-center h-full">
            <Spinner className="scale-[3]" />
          </div>
        ) : (
          <Chart
            type="bar"
            data={{
              labels: labelsForBar,
              datasets: [
                {
                  type: 'line' as const,
                  label: `${t('stats.trips')}`,
                  data: trips,
                  borderColor: '#FF8400',
                  borderWidth: 2,
                  fill: false,
                  datalabels: {
                    display: false,
                  },
                },
                {
                  type: 'bar' as const,
                  label: `${t('stats.amount')}`,
                  data: amounts,
                  backgroundColor: '#00A879',
                  datalabels: {
                    color: '#00A879',
                    anchor: 'end',
                    align: 'end',
                    offset: 0,

                    formatter: (value: number) => {
                      return `${value}€`;
                    },
                  },
                },
              ],
            }}
            plugins={[ChartDataLabels]}
            options={{
              scales: {
                x: {
                  grid: {
                    display: false,
                  },
                },
                y: {
                  grid: {
                    display: false,
                  },
                  max: Math.max(...amounts) + 100,
                },
              },
              responsive: true,
              maintainAspectRatio: false,
            }}
          />
        )}
      </div>
    </div>
  );
};
